import { render, staticRenderFns } from "./RevenueExpensesTable.vue?vue&type=template&id=6510cf30&"
import script from "./RevenueExpensesTable.vue?vue&type=script&lang=js&"
export * from "./RevenueExpensesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports